import { Button, Box, Card, CardActions, CardContent, Container, Typography } from "@mui/material";
import WavingHandIcon from '@mui/icons-material/WavingHand';
import ErrorIcon from '@mui/icons-material/Error';
import { Link, useSearchParams } from "react-router-dom";
import { DateTime } from 'luxon';
import { useAuth } from "../../AuthContext";
import { useMemo } from "react";
import { HELP_URL } from "../../constants";

export default function SubscribeCanceled() {
  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error'); // "testCode"

  
  const expireTime = useMemo(() => {
    if (auth.user.stripe.expiresAt) {
      return DateTime.fromISO(auth.user.stripe.expiresAt).toLocaleString(DateTime.DATE_FULL);
    }
    return 'Invalid Date';
  }, [auth.user.stripe.expiresAt]);

  return (
    <Container sx={{ p: 3 }} maxWidth="md">
      <Card>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center' }}>
            {error ? (
              <ErrorIcon sx={{ fontSize: 72 }} color="error" />
            ) : (
              <WavingHandIcon sx={{ fontSize: 72 }} color="secondary" />
            )}
          </Box>
          <Typography sx={{ textAlign: 'center', mt: 2 }} variant="h3">
            {error ? 'Something went wrong' : 'Your subscription has been canceled'}
          </Typography>
          <Typography sx={{ textAlign: 'center', mt: 2 }}>
            {error ? 
              'We were unable to cancel your subscription at this time. Please try again or contact support' :
              `You can continue to use OpenGolfSim Pro features until your current membership expires on ${expireTime}. Thanks for giving us a try!`
            }
          </Typography>
        </CardContent>
        <CardActions sx={{ justifyContent: 'center' }}>
          <Button component={Link} to="/account/billing" color="secondary" variant="contained">Back to account</Button>
          {error ? (
            <Button onClick={() => window.open(HELP_URL)} color="secondary" variant="contained">Contact Us</Button>
          ) : null}
          {/* <Button component={Link} to="/account/billing" variant="outlined">Back to Account</Button> */}
        </CardActions>
      </Card>
    </Container>
  );
}